import React, { Component } from 'react';
import { defineMessages, intlShape, injectIntl } from 'react-intl';

import ServerErrorText from '../components/messages/ServerErrorText';
import * as clientActions from '../actions/client';
import { META_TITLE_PREFIX } from '../constants';

const messages = defineMessages({
  serverError: {
    id: 'error.server.title',
    defaultMessage: 'Server error',
  },
});

class ServerError extends Component {
  static propTypes = {
    intl: intlShape,
  };

  static onDataFetch(store, params, location, intl) {
    store.dispatch(
      clientActions.setHelmet({
        title: META_TITLE_PREFIX + intl.formatMessage(messages.serverError),
      })
    );
  }

  render() {
    const { intl } = this.props;
    const serverError = intl.formatMessage(messages.serverError);

    return (
      <div className="u-page-container" role="main">
        <h1>{serverError}</h1>
        <p>
          <ServerErrorText />
        </p>
      </div>
    );
  }
}

export default injectIntl(ServerError);
